export function updateAConstExt(app, input) {
  // TODO: use constants iso app
  const selected_iol_model = app.IOLModelItems.find(
    (iolmodel) => iolmodel.type === input.iol_model.type,
  )
  input.aconst = selected_iol_model.aconst

  // for second calcul
  // input.is_second = false;
}
